import { miscHelpers } from '@approvalmax/utils';
import { hooks } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { routingService } from 'services/routing';
import { useSignInWith } from 'shared/hooks/(auth)/useSignInWith/useSignInWith';
import { SignInPostActionType } from 'shared/hooks/(auth)/useSignInWith/useSignInWith.types';
import { getPath, Path } from 'urlBuilder';

export const useSignInWithStartPageData = () => {
    const [initialStartingPoint] = hooks.useQueryParam<domain.SsoStartingPoint>('startingPoint');
    const [realmId] = hooks.useQueryParam('realmId');
    const [initialOAuthProvider] = hooks.useQueryParam('oauthProvider');
    const startingPoint = initialStartingPoint || domain.SsoStartingPoint.Marketplace;
    const oAuthProvider = initialOAuthProvider ? initialOAuthProvider.toLowerCase() : null;
    const shouldConnectOnSignIn =
        startingPoint === domain.SsoStartingPoint.Marketplace && oAuthProvider === domain.OAuthProvider.QBooks;

    const { onSignInWith } = useSignInWith({
        startingPoint,
        postAction: shouldConnectOnSignIn
            ? {
                  type: SignInPostActionType.Connect,
                  externalOrgId: realmId,
              }
            : undefined,
    });

    useEffect(() => {
        if (
            miscHelpers.isEnumValue(domain.OAuthProvider, oAuthProvider) &&
            miscHelpers.isEnumValue(domain.SsoStartingPoint, startingPoint)
        ) {
            onSignInWith(oAuthProvider);
        } else {
            routingService.push(getPath(Path.login));
        }
    }, [startingPoint, oAuthProvider, realmId, onSignInWith]);
};
